var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Episode-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Episodes/Work-Queue/After-Date-Range-Selection",
    transform: "translate(-355.000000, -523.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(355.499407, 523.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7891822,27.0941169 L4.49063063,27.0941169 C2.01469074,27.0941169 -1.08357767e-13,25.0782872 -1.08357767e-13,22.6034862 L-1.08357767e-13,5.83110039 C-1.08357767e-13,3.3551605 2.01469074,1.34046976 4.49063063,1.34046976 C4.74232462,1.34046976 4.94618535,1.54433049 4.94618535,1.79602448 C4.94618535,2.04771846 4.74232462,2.25157919 4.49063063,2.25157919 C2.51693982,2.25157919 0.911109436,3.85740958 0.911109436,5.83110039 L0.911109436,22.6023473 C0.911109436,24.5760382 2.51693982,26.1818685 4.49063063,26.1818685 L21.7891822,26.1818685 C23.762873,26.1818685 25.3687034,24.577177 25.3687034,22.6023473 L25.40287,5.82996151 C25.40287,3.85740958 23.7981785,2.25157919 21.8233488,2.25157919 C21.5716548,2.25157919 21.3677941,2.04771846 21.3677941,1.79602448 C21.3677941,1.54433049 21.5727937,1.34046976 21.8233488,1.34046976 C24.2992887,1.34046976 26.3139794,3.3551605 26.3139794,5.83110039 L26.2798128,22.6034862 C26.2798128,25.0782872 24.2651221,27.0941169 21.7891822,27.0941169 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4412567,2.25157919 L8.521151,2.25157919 C8.26945702,2.25157919 8.06559628,2.04771846 8.06559628,1.79602448 C8.06559628,1.54433049 8.26945702,1.34046976 8.521151,1.34046976 L11.4412567,1.34046976 C11.6929507,1.34046976 11.8968115,1.54433049 11.8968115,1.79602448 C11.8968115,2.04771846 11.6929507,2.25157919 11.4412567,2.25157919 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.636351, 0.009111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.953248248,4.37674195 C0.701554266,4.37674195 0.49769353,4.17288122 0.49769353,3.92118724 L0.49769353,0.455554718 C0.49769353,0.203860736 0.701554266,-1.37667655e-14 0.953248248,-1.37667655e-14 C1.20494223,-1.37667655e-14 1.40880297,0.203860736 1.40880297,0.455554718 L1.40880297,3.92004835 C1.40880297,4.17174233 1.20494223,4.37674195 0.953248248,4.37674195 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.953248248,
    cy: 3.92004835,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.9146893,2.25157919 L14.9945835,2.25157919 C14.7428896,2.25157919 14.5390288,2.04771846 14.5390288,1.79602448 C14.5390288,1.54433049 14.7440285,1.34046976 14.9945835,1.34046976 L17.9146893,1.34046976 C18.1663833,1.34046976 18.370244,1.54433049 18.370244,1.79602448 C18.370244,2.04771846 18.1652444,2.25157919 17.9146893,2.25157919 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.204311, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.953248248,4.37674195 C0.701554266,4.37674195 0.49769353,4.17288122 0.49769353,3.92118724 L0.49769353,0.455554718 C0.49769353,0.203860736 0.701554266,-1.42108547e-14 0.953248248,-1.42108547e-14 C1.20494223,-1.42108547e-14 1.40880297,0.203860736 1.40880297,0.455554718 L1.40880297,3.92004835 C1.40880297,4.17288122 1.20494223,4.37674195 0.953248248,4.37674195 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.953248248,
    cy: 3.92118724,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(18.772271, 0.009111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.953248248,4.37674195 C0.701554266,4.37674195 0.49769353,4.17288122 0.49769353,3.92118724 L0.49769353,0.455554718 C0.49769353,0.203860736 0.702693153,-1.37667655e-14 0.953248248,-1.37667655e-14 C1.20380334,-1.37667655e-14 1.40880297,0.203860736 1.40880297,0.455554718 L1.40880297,3.92004835 C1.40880297,4.17174233 1.20380334,4.37674195 0.953248248,4.37674195 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.953248248,
    cy: 3.92004835,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEmpty);
export default __webpack_public_path__ + "static/media/calendar-empty.7be5a230c4d2178dc2044d2037249b01.svg";
export { ForwardRef as ReactComponent };